<p>faq-license works!</p>
